@if (totalItems > pageSize) {
	<ngb-pagination
		[ngClass]="classes"
		[collectionSize]="totalItems"
		[(page)]="currentPage"
		(pageChange)="currentPageChange.emit($event)"
		[pageSize]="pageSize"
		[maxSize]="maximumPages"
		[ellipses]="true"
		size="sm"
	>
		<ng-template ngbPaginationPrevious>Previous</ng-template>
		<ng-template ngbPaginationNext>Next</ng-template>
	</ngb-pagination>
}
